import { cn } from "@/lib/utils";
import React from "react";

interface BaseCardProps {
  onClick: () => void;
  disabled?: boolean;
  ariaLabel: string;
  children: React.ReactNode;
  className?: string; // Optional for additional styling
}

const BaseCard = ({
  onClick,
  disabled,
  ariaLabel,
  children,
  className,
}: BaseCardProps) => {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
      className={cn(
        "group relative flex w-full flex-col rounded-lg border border-gray-200 bg-white overflow-hidden shadow-sm transition-all duration-200 hover:border-primary/50 hover:shadow-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40 focus-visible:ring-offset-1",
        (disabled) && "cursor-not-allowed opacity-60 hover:shadow-sm",
        className
      )}
    >
      {children}
    </button>
  );
};

export default BaseCard;
